import { Deserializable } from '../../../../protocols/deserializable';
import { EmployerContactSubmissionData } from './employer-contact-submission-data';

export class UpdateEmployerContactsSubmissionData implements Deserializable {
  public contacts: EmployerContactSubmissionData[] = [];

  public onDeserialize() {
    if (this.contacts.length) {
      this.contacts = window?.injector?.Deserialize?.arrayOf(EmployerContactSubmissionData, this.contacts);
    }
  }
}
